export const createNumberArrayOptions = (n) =>{
    const result = [];
    for (let i = 1; i <= n; i++) {
        result.push(i);
    }
    let data = result?.map((num) => {
        return  { label: num, value: num}
    });
    return data;
}

export const createNumberArray = (n) =>{
    const result = [];
    for (let i = 1; i <= n; i++) {
        result.push(i);
    }
    return result;
}